// extracted by mini-css-extract-plugin
export default {"headerTitle":"headerTitle__2sC4W"};
    if(module.hot) {
      // 1790586311689
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  